import _ from 'lodash'

const srcSwapper = (el, remote) => {
  const images = Array.from(el.querySelectorAll('img'))
  _.forEach(images, img => {
    if (typeof img.dataset.oldSrc === 'undefined' ||
    img.dataset.oldSrc === null ||
    img.dataset.oldSrc.length <= 0) img.dataset.oldSrc = img.getAttribute('src')

    img.setAttribute('src', `${remote}${img.dataset.oldSrc}`)
  })
}

const VueAbsolutePath = {
  install (Vue, { remote }) {
    Vue.directive('absolute-path', {
      bind: (el, binding) => {
        srcSwapper(el, binding.value || remote)
      },
      update: (el, binding) => {
        srcSwapper(el, binding.value || remote)
      }
    })
  }
}

export default VueAbsolutePath
